import { FilterValue } from '~/apis/search';
import { CategoryItem } from '~/services/category/category.type';

const CODE_LENGTH = 3;

/** 카테고리 ID에 해당하는 [1depth, 2depth, 3depth] 카테고리를 찾아 반환합니다. */
export const findBreadcrumb = (id: string = '', categories: FilterValue[]): CategoryItem[] => {
  const _id = `${id}`;
  const [depth1, depth2, depth3] = [
    _id?.substring(0, CODE_LENGTH),
    (_id?.length || 0) >= CODE_LENGTH * 2 && _id?.substring(0, CODE_LENGTH * 2),
    (_id?.length || 0) >= CODE_LENGTH * 3 && _id?.substring(0, CODE_LENGTH * 3),
  ];

  const depth1Category = categories;
  const depth1CategoryName = categories.find(({ value }) => value === depth1)?.name;
  const depth1CategoryValue = categories.find(({ value }) => value === depth1)?.value;

  const depth2Category = categories.find(({ value }) => value === depth1)?.children;
  const depth2CategoryName = depth2Category?.find(({ value }) => value === depth2)?.name;
  const depth2CategoryValue = depth2Category?.find(({ value }) => value === depth2)?.value;

  const depth3Category = depth2Category?.find(({ value }) => value === depth2)?.children;
  const depth3CategoryName = depth3Category?.find(({ value }) => value === depth3)?.name;
  const depth3CategoryValue = depth3Category?.find(({ value }) => value === depth3)?.value;

  const result: CategoryItem[] = [
    { categories: depth1Category, value: depth1CategoryValue ?? '', name: depth1CategoryName ?? '' },
  ];

  depth2Category &&
    result.push({
      categories: depth2Category,
      value: depth2CategoryValue ?? '',
      name: depth2CategoryName ?? '',
    });

  depth3Category &&
    result.push({
      categories: depth3Category,
      value: depth3CategoryValue ?? '',
      name: depth3CategoryName ?? '',
    });

  return result;
};
